function onZoom(e,zoomClass){
    // Use the parent container to get stable unscaled dimensions and positions
    const parentContainer = zoomClass.closest('.media-container') || zoomClass.closest('.media-grid-inner') || zoomClass.parentNode;
    const rect = parentContainer.getBoundingClientRect();
    
    // Get mouse/touch coordinates relative to the image
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
    
    let x = clientX - rect.left;
    let y = clientY - rect.top;
    
    // Calculate percentages
    let xPercent = (x / rect.width) * 100;
    let yPercent = (y / rect.height) * 100;
    
    // Constrain to 0-100% just in case
    xPercent = Math.max(0, Math.min(100, xPercent));
    yPercent = Math.max(0, Math.min(100, yPercent));
    
    if (isNaN(xPercent) || isNaN(yPercent)) {
      xPercent = 50;
      yPercent = 50;
    }
    
    zoomClass.dataset.originX = xPercent;
    zoomClass.dataset.originY = yPercent;
    
    if (window.innerWidth < 992) {
      zoomClass.style.setProperty('transform-origin', `${xPercent}% ${yPercent}%`, 'important');
      zoomClass.style.setProperty('transform', 'scale(2.2)', 'important');
    } else {
      zoomClass.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      zoomClass.style.transform = "scale(2.2)";
    }
}
function offZoom(e,zoomClass){
    delete zoomClass.dataset.originX;
    delete zoomClass.dataset.originY;
    if (window.innerWidth < 992) {
      zoomClass.style.removeProperty('transform-origin');
      zoomClass.style.removeProperty('transform');
    } else {
      zoomClass.style.transformOrigin = `center center`;
      zoomClass.style.transform = "scale(1)";
    }
}
document.querySelectorAll(".product-image-zoom").forEach(function(zoomClass){
  zoomClass.addEventListener('click',function(e,ie){
    let index = [...e.target.closest(".medialist").children].indexOf(e.target.closest(".media-grid-column"));
    document.querySelectorAll(".media-grid-column").forEach(function(mediaGrid,i){
      if(i != index){
        mediaGrid.classList.remove('active');
        var sibling_Class = mediaGrid.querySelector('.product-image-zoom');
        if(sibling_Class){
          offZoom(e,sibling_Class);
        }
      }
    });
    
    const parentColumn = zoomClass.closest('.media-grid-column');
    parentColumn.classList.toggle('active');
    
    if(parentColumn.classList.contains('active')){
      onZoom(e,zoomClass);
    }else{
      offZoom(e,zoomClass);
    }
  });

  zoomClass.addEventListener('mouseleave',function(e){
    offZoom(e,zoomClass);
    zoomClass.closest('.media-grid-column').classList.remove('active');
  });

  zoomClass.addEventListener('mousemove',function(e){
    let active_zoom = document.querySelector('.media-grid-column.active .product-image-zoom');
    if(active_zoom){
      onZoom(e,active_zoom);
    }
  });

  // Touch panning event listeners for mobile devices
  let startX = 0;
  let startY = 0;
  let startOriginX = 50;
  let startOriginY = 50;

  zoomClass.addEventListener('touchstart', function(e) {
    const parentColumn = zoomClass.closest('.media-grid-column');
    if (parentColumn && parentColumn.classList.contains('active')) {
      if (!e.touches || e.touches.length === 0) return;
      
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      
      startOriginX = parseFloat(zoomClass.dataset.originX || '50');
      startOriginY = parseFloat(zoomClass.dataset.originY || '50');
      
      e.stopPropagation();
    }
  }, { passive: false });

  zoomClass.addEventListener('touchmove', function(e) {
    const parentColumn = zoomClass.closest('.media-grid-column');
    if (parentColumn && parentColumn.classList.contains('active')) {
      if (!e.touches || e.touches.length === 0) return;
      e.preventDefault();
      e.stopPropagation();

      const touch = e.touches[0];
      const parentContainer = zoomClass.closest('.media-container') || zoomClass.closest('.media-grid-inner') || zoomClass.parentNode;
      const rect = parentContainer.getBoundingClientRect();

      let diffX = touch.clientX - startX;
      let diffY = touch.clientY - startY;

      let percentDiffX = (diffX / rect.width) * 100;
      let percentDiffY = (diffY / rect.height) * 100;

      // scale is 2.2, so scale - 1 = 1.2
      let newOriginX = startOriginX - (percentDiffX / 1.2);
      let newOriginY = startOriginY - (percentDiffY / 1.2);

      newOriginX = Math.max(0, Math.min(100, newOriginX));
      newOriginY = Math.max(0, Math.min(100, newOriginY));

      zoomClass.dataset.originX = newOriginX;
      zoomClass.dataset.originY = newOriginY;

      zoomClass.style.setProperty('transform-origin', `${newOriginX}% ${newOriginY}%`, 'important');
      zoomClass.style.setProperty('transform', 'scale(2.2)', 'important');
    }
  }, { passive: false });

  zoomClass.addEventListener('touchend', function(e) {
    const parentColumn = zoomClass.closest('.media-grid-column');
    if (parentColumn && parentColumn.classList.contains('active')) {
      e.stopPropagation();
    }
  }, { passive: false });

  // MutationObserver to clean up styles if class active is removed
  const parentColumn = zoomClass.closest('.media-grid-column');
  if (parentColumn) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const isActive = parentColumn.classList.contains('active');
          if (!isActive) {
            offZoom(null, zoomClass);
          }
        }
      });
    });
    observer.observe(parentColumn, { attributes: true });
  }
});